const SUBSCRIPTION_DIALOGS_DEFAULT_STATE = {
	isSubscriptionModalOpen: false,
	isSubscriptionSucessModalOpen: false,
	isSubscriptionErrorModalOpen: false,
	isSubscriptionInfoModalOpen: false,
};

export {SUBSCRIPTION_DIALOGS_DEFAULT_STATE};
